module.exports = __webpack_public_path__ + "img/audiology_parameters.ef2f9944.svg";